/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";

export function useAnimatedNumber(target: number, duration: number = 500) {
  const [value, setValue] = useState(target);

  const frame = useRef<number>();
  const lastTarget = useRef(target);
  const lastValue = useRef(target);

  useEffect(() => {
    const start = performance.now();
    const startValue = lastValue.current;
    const endValue = target;
    lastTarget.current = target;

    const animate = (now: number) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);

      const eased = progress * (2 - progress);

      const current = startValue + (endValue - startValue) * eased;

      lastValue.current = current;
      setValue(current);

      if (progress < 1) {
        frame.current = requestAnimationFrame(animate);
      }
    };

    if (frame.current) cancelAnimationFrame(frame.current);
    frame.current = requestAnimationFrame(animate);

    return () => {
      if (frame.current) cancelAnimationFrame(frame.current);
    };
  }, [target]);

  return Math.round(value);
}
